export default "57d8c6207dbf4e40.png"